export const ResearcherPosition = "ResearcherPosition";
export const Institution = "Institution";
export const SubInstitution = "SubInstitution";
export const Position = "ResearcherPosition";
export const AreaOfInterest = "AreaOfInterest";
export const ExperienceRating = "ExperienceRating";
export const Respondent = "Respondent";
export const ActivityType = "ActivityType";
export const ConsultationType = "ConsultationType";
export const IssueReferred = "IssueReferred";
export const StudyDevelopmentType = "StudyDevelopmentType";
export const ResearchSiteCollaboration = "ResearchSiteCollaboration";
export const ClinicalTrialsGovAssistance = "ClinicalTrialsGovAssistance";
export const BiostatisticsAssistance = "BiostatisticsAssistance";
export const RegulatoryGuidance = "RegulatoryGuidance";
export const OutreachEvent = "OutreachEvent";
export const CrtuRequest = "CrtuRequest";
export const ResearchMatchRequest = "ResearchMatchRequest";
export const Respondents = "Respondents";